export default "__VITE_ASSET__CjxcKkaQ__"